import Hero from "../components/Hero";
import LayeredHydration from "../components/LayeredHydration";
import ProductFeature from "../components/ProductFeature";
import InsideFormula from "../components/InsideFormula";
import Philosophy from "../components/Philosophy";
import Reviews from "../components/Reviews";
import Journal from "../components/Journal";

export default function Landing({ ready }) {
  return (
    <>
      <Hero ready={ready} />
      <LayeredHydration />
      <ProductFeature />
      <InsideFormula />
      <Philosophy />
      <Reviews />
      <Journal />
    </>
  );
}
